// Enums baseados nos DTOs fornecidos
export enum TourDifficultyEnum {
  EASY = 'easy',
  MODERATE = 'medium',
  HARD = 'hard',
}

export type TourInclude = {
  id: number
  tourId: number
  item: string
  orderIndex: number
}

export type TourSchedule = {
  id: number
  tourId: number
  startTime: string
  daysOfWeek: number[]
  seasonalStart?: string | null
  seasonalEnd?: string | null
  status: boolean
}

// Itens padrão que um tour pode oferecer
export const TOUR_INCLUDES_OPTIONS = [
  'Transporte ida e volta',
  'Guia turístico especializado', 
  'Entrada em atrações',
  'Almoço ou lanche',
  'Água mineral',
  'Equipamentos de segurança',
  'Seguro de acidentes pessoais',
  'Material informativo',
  'Fotografia profissional',
  'Degustação local',
  'Equipamentos especializados',
  'Wi-Fi no transporte',
  'Kit primeiros socorros',
  'Certificado de participação',
  'Brindes ou souvenirs'
]

// Dias da semana para os horários
export const DAYS_OF_WEEK = [
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
]

export type HotelTourType = {
  id: number
  pluginspaceId: number
  title: string
  description?: string | null
  duration?: string | null
  difficulty: TourDifficultyEnum
  price?: number | null
  currency: string
  rating: number
  image?: string | null
  status: boolean
  requiresReservation: boolean
  maxParticipants?: number | null
  minParticipants: number
  ageRestriction?: string | null
  physicalRequirements?: string | null
  weatherDependent: boolean
  cancellationHours: number
  discountChildren: number
  includesTransfer: boolean
  created?: Date | null
  updated?: Date | null
  tourIncludes?: TourInclude[]
  tourSchedules?: TourSchedule[]
}

export type CreateHotelTourDto = {
  title: string
  description?: string
  duration?: string
  difficulty?: TourDifficultyEnum
  price?: number
  currency?: string
  rating?: number
  image?: string
  status?: boolean
  requiresReservation?: boolean
  maxParticipants?: number
  minParticipants?: number
  ageRestriction?: string
  physicalRequirements?: string
  weatherDependent?: boolean
  cancellationHours?: number
  discountChildren?: number
  includesTransfer?: boolean
}

export type UpdateHotelTourDto = {
  title?: string
  description?: string
  duration?: string
  difficulty?: TourDifficultyEnum
  price?: number
  currency?: string
  rating?: number
  image?: string
  status?: boolean
  requiresReservation?: boolean
  maxParticipants?: number
  minParticipants?: number
  ageRestriction?: string
  physicalRequirements?: string
  weatherDependent?: boolean
  cancellationHours?: number
  discountChildren?: number
  includesTransfer?: boolean
}

// Funções utilitárias para labels
export const getDifficultyLabel = (difficulty: TourDifficultyEnum): string => {
  const difficultyLabels: Record<TourDifficultyEnum, string> = {
    [TourDifficultyEnum.EASY]: 'Fácil',
    [TourDifficultyEnum.MODERATE]: 'Moderado',
    [TourDifficultyEnum.HARD]: 'Difícil',

  }
  return difficultyLabels[difficulty] || difficulty
}

export const getDifficultyColor = (difficulty: TourDifficultyEnum): string => {
  const colors: Record<TourDifficultyEnum, string> = {
    [TourDifficultyEnum.EASY]: 'success',
    [TourDifficultyEnum.MODERATE]: 'warning',
    [TourDifficultyEnum.HARD]: 'danger',
  }
  return colors[difficulty] || 'secondary'
}

export const formatCurrency = (amount: number | string | null, currency: string = 'BRL'): string => {
  if (amount === null || amount === undefined || amount === '') return 'Gratuito'
  
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount
  if (isNaN(numericAmount)) return 'Gratuito'
  
  const currencySymbols: Record<string, string> = {
    BRL: 'R$',
    USD: '$',
    EUR: '€',
  }
  
  const symbol = currencySymbols[currency] || currency
  return `${symbol} ${numericAmount.toFixed(2)}`
}

export const formatRating = (rating: number | string): string => {
  const numericRating = typeof rating === 'string' ? parseFloat(rating) : rating
  if (isNaN(numericRating)) return '0.0 ⭐'
  return `${numericRating.toFixed(1)} ⭐`
}

export const formatSchedules = (schedules: TourSchedule[]): string => {
  if (!schedules || schedules.length === 0) return 'Nenhum horário'
  
  const activeTimes = schedules
    .filter(schedule => schedule.status)
    .map(schedule => schedule.startTime.substring(0, 5)) // Remove seconds
    .join(', ')
    
  return activeTimes || 'Nenhum horário ativo'
}

export const formatIncludes = (includes: TourInclude[]): string => {
  if (!includes || includes.length === 0) return 'Nenhum item incluído'
  
  const sortedIncludes = includes
    .sort((a, b) => a.orderIndex - b.orderIndex)
    .map(item => item.item)
    .slice(0, 3) // Mostra apenas os 3 primeiros
    
  const result = sortedIncludes.join(', ')
  return includes.length > 3 ? `${result}...` : result
}

